import { colord } from 'colord';

const colors = {
  primary: colord('#609aae'),
  logo: colord('#b0c8d4'),
  lightest: colord('#ffffff'),
  lighter: colord('#E6ECEF'),
  light: colord('#E6ECEF'),
  dark: colord('#000000'),
};

const textSize = {
  xs: '0.75rem',
  s: '0.875rem',
  m: '1rem',
  l: '1.2rem',
  xl: '1.5rem',
};

const lineHeight = {
  xs: `calc(1.3 * ${textSize.xs})`,
  s: `calc(1.4 * ${textSize.s})`,
  m: `calc(1.5 * ${textSize.m})`,
  l: `calc(1.35 * ${textSize.l})`,
  xl: `calc(1.4 * ${textSize.xl})`,
};

const fontWeight = {
  bold: '600',
  medium: '500',
  regular: '400',
  thin: '300',
};

export const light = {
  textSize,
  lineHeight,
  fontWeight,
  colors,
  defaultSpacing: '1rem',
  backgroundColor: colors.lightest,
  warningColor: colord('#FFBD00'),
  dangerColor: colord('#b13030'),
  textColor: colors.dark,
  linkColor: colors.primary.lighten(0.2),
  input: {
    background: colors.dark,
    textColor: colors.light,
    padding: '0.8em',
    disabled: {
      opacity: 0.9,
    },
  },
  link: {
    primaryColor: colord('#00A7F7'),
    dangerColor: colord('#b13030'),
    underlined: true,
  },
  button: {
    default: {
      backgroundColor: colord('#00A7F7'),
      color: colors.lightest,
    },
    primary: {
      backgroundColor: colord('#00A7F7'),
      color: colors.lightest,
    },
    danger: {
      backgroundColor: colord('#ff9999'),
      color: colord('#b13030'),
    },
  },
  border: {
    width: '2px',
    radius: 0,
    color: {
      default: colors.light,
      focus: colors.primary,
    },
  },
};

export const dark = {
  textSize,
  lineHeight,
  fontWeight,
  colors,
  defaultSpacing: '1rem',
  backgroundColor: colors.dark,
  warningColor: colord('#FFBD00'),
  dangerColor: colord('#b13030'),
  textColor: colors.light,
  linkColor: colors.primary.lighten(0.2),
  input: {
    background: colors.light,
    textColor: colors.dark,
    padding: '0.8em',
    disabled: {
      opacity: 0.7,
    },
  },
  link: {
    primaryColor: colors.light,
    dangerColor: colord('#b13030'),
    underlined: true,
  },
  button: {
    default: {
      backgroundColor: colord("#808080"),
      color: colors.lightest,
    },
    primary: {
      backgroundColor: colors.primary,
      color: colors.lightest,
    },
    danger: {
      backgroundColor: colord('#ff9999'),
      color: colord('#b13030'),
    },
  },
  border: {
    width: '2px',
    radius: 0,
    color: {
      default: colors.primary.lighten(0.2),
      focus: colors.primary,
    },
  },
};

export default light;
